import { CreateButton } from 'components/button/CreateButton';
import { DocumentTitle } from 'components/DocumentTitle';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { TablePageLayout } from 'components/page/styled';
import { usePermissions } from 'contexts/PermissionsContext';
import { usePagedAssetCategoryTypeDataSource } from 'custom_hooks/data_hooks/data_source/assetCategoryTypeDataSource';
import { AssetTypeDetailsPage } from 'pages/Settings/AssetType/AssetTypeDetailsPage';
import { AssetTypesTable } from 'pages/Settings/AssetType/AssetTypesTable';
import { CreateAssetTypeModal } from 'pages/Settings/AssetType/CreateAssetTypeModal';
import { SearchCreateButtonContainer } from 'pages/Settings/shared/styled';
import { useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

export function AssetTypesPage() {
    const { canEditAssetType: canCreateAssetType } = usePermissions();
    const { url } = useRouteMatch();

    const dataSource = usePagedAssetCategoryTypeDataSource({
        name: 'asset-types-table',
        defaultFilter: {
            nameSearch: '',
        },
    });

    const { setFilter, reset, reloadPage } = dataSource;
    const [showCreateAssetTypeModal, setShowCreateAssetTypeModal] = useState(false);
    const [nameSearch, setNameSearch] = useState('');

    const onClose = (saved: boolean) => {
        setShowCreateAssetTypeModal(false);
        if (saved) {
            reset();
            reloadPage();
        }
    };

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch,
        }));
    }, [nameSearch, setFilter]);

    return (
        <>
            <DocumentTitle title="Asset Type Settings" />
            <Switch>
                <Route
                    path={`${url}/:assetTypeId`}
                    render={({ match }) => (
                        <AssetTypeDetailsPage
                            assetTypeId={Number(match.params.assetTypeId)}
                        />
                    )}
                />
                {/* @ts-expect-error: type issue with older version of react-router-dom */}
                <Route default>
                    <TablePageLayout>
                        <SearchCreateButtonContainer>
                            <DebouncedSearchInput
                                placeholder="Search"
                                value={nameSearch}
                                onChange={setNameSearch}
                            />
                            {canCreateAssetType && (
                                <CreateButton
                                    onClick={() => setShowCreateAssetTypeModal(true)}
                                />
                            )}
                            {showCreateAssetTypeModal && (
                                <CreateAssetTypeModal onClose={onClose} />
                            )}
                        </SearchCreateButtonContainer>
                        <AssetTypesTable dataSource={dataSource} />
                    </TablePageLayout>
                </Route>
            </Switch>
        </>
    );
}
